import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './CanceledPage.css';

const CanceledPage = () => {
    const navigate = useNavigate();
    
    useEffect(() => {
        // Automatically redirect after 5 seconds
        const timer = setTimeout(() => {
            navigate('/auth-home');
        }, 5000);
        
        return () => clearTimeout(timer);
    }, [navigate]);
    
    return (
        <div className="canceled-page">
            <div className="canceled-container">
                <h2>Subscription Canceled</h2>
                <p>Your subscription was not completed.</p>
                <p>You will be redirected to the dashboard in 5 seconds.</p>
                <Link to="/auth-home" className="return-link">Return to Dashboard Now</Link>
            </div>
        </div>
    );
};

export default CanceledPage;
